import '../styles/TechnologiesCloud.scss'
import src1 from "../images/techologies_page/technologies_more_card_icon_first.png"
import src2 from "../images/techologies_page/technologies_more_card_icon_second.png"
import src3 from "../images/techologies_page/technologies_more_card_icon_third.png"
import {Col, Row} from "react-simple-flex-grid";
import {Chip} from "./Chip";
import {useNavigate} from "react-router-dom";

export const TechnologiesMore = () => {
    const cards = [
        {
            imageSrc: src1,
            title: 'Blockchain & NFT',
            description: 'As a result of the experience we generate NFT with the digital avatar of the visitor and prediction about their future role in the metaverse.',
            chips: ['security', 'finance', 'art']
        },
        {
            imageSrc: src2,
            title: 'Mid-air haptics',
            description: "To provide a sense of touch and unable to feel some digital sensations while interacting with the digital human Alnair. There is also a motion control camera that recognizes the hand position and gestures the visitor does to navigate through the experience.",
            chips: ['entertainment', 'automotive', 'retail']
        },
        {
            imageSrc: src3,
            title: 'Human-machine interaction',
            description: "We use the interactive kiosk to provide an immersive experience. The visitor visually interacts with the Alnair  which broadcasts from the kiosk.",
            chips: ['retail', 'public sector', 'entertainment']
        }
    ]

    const navigate = useNavigate();

    return <>
        <Row>
            <Col span={12}>
                <h3 className="technologies-more-title">
                    and more...
                </h3>
            </Col>
        </Row>
        <Row gutter={5}>
            {cards && cards.map((item, index) => {
                return <Col xs={12} sm={4} key={index} className="tech-more-cards-column">
                    <div className="tech-more-card">
                        <div className="card-icon">
                            <img src={item.imageSrc} alt={`item ${index}`}/>
                        </div>
                        <div className="card-title">
                            {item.title}
                        </div>
                        <div className="card-description">
                            {item.description}
                        </div>
                        <div className="card-chips">
                            {item.chips.map((chip, chipIndex) => <Chip chip={chip} key={chipIndex}/>)}
                        </div>
                    </div>
                </Col>
            })}
        </Row>
        <Row>
            <Col span={12}>
                <div className="inspired-enough-block" onClick={() => navigate('/contact-us')}>
                    <h5>Inspired enough? <br/>Let’s create the future together </h5>
                    <div className="join-us-link">
                        join us
                        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                            <path d="M0 2H49M49 2V48M49 2L4 48" stroke="#FDEEEE" strokeWidth="4"/>
                        </svg>
                    </div>
                </div>
            </Col>
        </Row>
    </>
}